module.exports = __webpack_public_path__ + "static/img/20.dbfce5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/20.png
// module id = y17u
// module chunks = 0